module.exports = __webpack_public_path__ + "static/img/solution_img_5.d986a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-h/solution_img_5.png
// module id = pVLZ
// module chunks = 22